import { CurrentBonuses } from "../interfaces/BonusSourceDetails";
import { IXPModule } from "../interfaces/IXPModule";
import { RuleModule } from "./RuleModule";
import { Improvement } from "../interfaces/Improvement";
import { SpendablesForModules } from "../interfaces/SpendablesForModules";
import { CharacterHistory } from "./CharacterHistory";

export class CalculateSpendableModules {
  ruleModuleInfo: { [ruleModuleKey: string]: RuleModule } = {};
  currentSpendables: SpendablesForModules = {};

  calculateSpendableModules(
    currentBonuses: CurrentBonuses,
    characterHistory: CharacterHistory,
    ruleModules: RuleModule[],
    xpModules: IXPModule[]
  ) {
    this.addRuleModuleInfo(ruleModules);
    this.mapSpendables(currentBonuses, characterHistory, xpModules);
    return this.currentSpendables;
  }

  addRuleModuleInfo(ruleModules: RuleModule[]) {
    ruleModules.forEach((module) => {
      this.ruleModuleInfo[module.key] = module;
    });
  }

  mapSpendables(
    currentBonuses: CurrentBonuses,
    characterHistory: CharacterHistory,
    xpModules: IXPModule[]
  ) {
    xpModules.forEach((xpModule: IXPModule) => {
      if (xpModule.usageRules) {
        const improvements = xpModule.usageRules.improvementsForModules;
        Object.keys(improvements).forEach((moduleKey: string) => {
          this.addSpendableImprovement(
            moduleKey,
            xpModule.name,
            improvements[moduleKey]
          );
        });
      }
    });
  }

  addSpendableImprovement(
    moduleKey: string,
    xpModuleName: string,
    improvement: Improvement
  ) {
    if (!Boolean(this.currentSpendables[moduleKey])) {
      this.currentSpendables[moduleKey] = [];
    }
    this.currentSpendables[moduleKey].push({
      name: xpModuleName,
      ...improvement,
    });
  }
}
